// step9.js - Incidents (Enhanced with photo upload support)
import ModernDataTable from '../ui/ModernDataTable';

const Step9 = ({
      incidentItems,
      setIncidentItems,
      defaultDateTime,
      enablePhotoUpload,
      referenceNo,
      sectionName,
      dataTableRef
}) => {
      const incidentFields = [
            {
                  name: 'timeRaised',
                  type: 'datetime',
                  label: 'Time raised',
                  header: 'Time raised',
                  required: true,
                  validationMessage: 'Please enter when the incident was first identified',
                  hint: 'Record the exact time when the incident occurred or was first reported. This is critical for incident investigation and reporting.'
            },
            {
                  name: 'location',
                  type: 'text',
                  label: 'Location',
                  header: 'Location',
                  placeholder: 'Specific location where the incident occurred',
                  required: true,
                  validationMessage: 'Please specify the exact location where the incident occurred',
                  hint: 'Provide precise location details including level, section, room number, and any relevant landmarks for incident investigation purposes.'
            },
            {
                  name: 'incidentCategory',
                  type: 'dropdown',
                  label: 'Incident category',
                  header: 'Incident category',
                  placeholder: 'Select the type of incident',
                  options: [
                        { value: 'Medical Emergency', label: 'Medical Emergency' },
                        { value: 'Fight', label: 'Fight' },
                        { value: 'Fire/Evacuation', label: 'Fire/Evacuation' },
                        { value: 'Security Incident', label: 'Security Incident' },
                        { value: 'Property Damage', label: 'Property Damage' },
                        { value: 'Slip/Trip/Fall', label: 'Slip/Trip/Fall' },
                        { value: 'Equipment Failure', label: 'Equipment Failure' },
                        { value: 'Crowd Control', label: 'Crowd Control' },
                        { value: 'Weather Related', label: 'Weather Related' },
                        { value: 'Other Incident', label: 'Other Incident' },
                  ],
                  required: true,
                  validationMessage: 'Please select the appropriate incident category from the dropdown',
                  hint: 'Choose the category that best describes the type of incident that occurred.'
            },
            {
                  name: 'customIncidentCategory',
                  type: 'text',
                  label: 'Custom incident category',
                  header: 'Custom category',
                  placeholder: 'Specify custom incident type if "Other Incident" selected',
                  hideUntil: {
                        condition: (data) => data.incidentCategory === 'Other Incident'
                  },
                  conditionalRequired: {
                        condition: (data) => data.incidentCategory === 'Other Incident',
                        message: 'Please specify the custom incident category'
                  },
                  hint: 'Provide a specific description of the incident type when "Other Incident" is selected.'
            },
            {
                  name: 'incidentSeverity',
                  type: 'dropdown',
                  label: 'Incident severity',
                  header: 'Severity',
                  placeholder: 'Assess the severity of this incident',
                  options: [
                        { value: 'Minor - No injuries or damage', label: 'Minor - No injuries or damage' },
                        { value: 'Moderate - Minor injuries or limited damage', label: 'Moderate - Minor injuries or limited damage' },
                        { value: 'Major - Serious injuries or significant damage', label: 'Major - Serious injuries or significant damage' },
                        { value: 'Critical - Life threatening or extensive damage', label: 'Critical - Life threatening or extensive damage' },
                  ],
                  required: true,
                  validationMessage: 'Please assess and select the severity level of this incident',
                  hint: 'Assess the severity based on the actual or potential impact including injuries, damage, and operational disruption.'
            },
            {
                  name: 'actionsTaken',
                  type: 'textarea',
                  label: 'Actions taken',
                  header: 'Actions taken',
                  placeholder: 'Describe actions taken to address this incident...',
                  required: false,
                  validationMessage: 'Please describe the actions taken to address this incident',
                  hint: (
                        <div>
                              <p style={{ margin: '0 0 0.5rem 0', fontWeight: '500' }}>Document immediate response actions including:</p>
                              <ul style={{ margin: 0, paddingLeft: '1rem' }}>
                                    <li>First aid or medical assistance provided</li>
                                    <li>Emergency services contacted (if applicable)</li>
                                    <li>Area secured or hazards isolated</li>
                                    <li>Witnesses identified and details recorded</li>
                                    <li>Evidence preservation or photography</li>
                                    <li>Supervisor or management notification</li>
                                    <li>Incident reporting procedures followed</li>
                                    <li>Follow-up actions planned or completed</li>
                              </ul>
                        </div>
                  )
            }
      ];

      return (
            <ModernDataTable
                  suppressTitle={true}
                  data={incidentItems}
                  setData={setIncidentItems}
                  fields={incidentFields}
                  addButtonText="Add Incident"
                  emptyMessage="No incidents added yet."
                  truncateLines={2}
                  defaultDateTime={defaultDateTime}
                  enablePhotoUpload={enablePhotoUpload}
                  referenceNo={referenceNo}
                  sectionName={sectionName}
                  ref={dataTableRef}
            />
      );
};

export default Step9;